import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import WifiIcon from '@material-ui/icons/Wifi';
import SignalWifiOffIcon from '@material-ui/icons/SignalWifiOff';
import DeviceUnknownIcon from '@material-ui/icons/DeviceUnknown';
import PermScanWifiIcon from '@material-ui/icons/PermScanWifi';
import ErrorIcon from '@material-ui/icons/Error';

const statusEnum = ['Unknown', 'Inactive', 'Active', 'Offline', 'Error'];

const useStyles = makeStyles(() => ({
  high: {
    fill: '#26A66A',
  },
  med: {
    fill: '#FFCB75',
  },
  low: {
    fill: '#E04828',
  },
  textWrapper: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  text: {
    paddingLeft: 5,
  },
}));

const DeviceStatus = ({ status, showText }) => {
  const classes = useStyles();
  const getIconByStatus = () => {
    if (status === 0) {
      // unknown
      return <DeviceUnknownIcon className={classes.med} />;
    }
    if (status === 1) {
      // inactive
      return <SignalWifiOffIcon className={classes.med} />;
    }
    if (status === 2) {
      // active
      return <WifiIcon className={classes.high} />;
    }
    if (status === 3) {
      // offline
      return <PermScanWifiIcon className={classes.low} />;
    }
    return <ErrorIcon className={classes.low} />;
  };
  return (
    <div className={showText ? classes.textWrapper : ''}>
      {getIconByStatus()}
      {showText && <div className={classes.text}>{statusEnum[status]}</div>}
    </div>
  );
};

DeviceStatus.propTypes = {
  status: PropTypes.number.isRequired,
  showText: PropTypes.bool,
};
DeviceStatus.defaultProps = {
  showText: false,
};

export default DeviceStatus;
